export var chart1 = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  subtitle: {
      text: ''
  },
  xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: { // don't display the dummy year
          month: '%e. %b',
          year: '%Y'
      },
      title: {
          text: ''
      }
  },
  yAxis: {
      title: {
          text: ''
      },
      min: 0
  },
  tooltip: {
      headerFormat: '<b>{series.name}</b><br>',
      pointFormat: '{point.x:%e. %b \'%y}: {point.y} complaints '
  },

  plotOptions: {
      spline: {
          marker: {
              enabled: true
          }
      }
  },

  colors: ['#FFA300'],

  // Define the data points. All series have a dummy year
  // of 1970/71 in order to be compared on the same x axis. Note
  // that in JavaScript, months start at 0 for January, 1 for February etc.
  series: [{
      name: "Complaints per day",
      data: [
        [Date.UTC(2010,2-1,7),1],
[Date.UTC(2010,4-1,1),1],
[Date.UTC(2010,4-1,3),1],
[Date.UTC(2010,4-1,4),2],
[Date.UTC(2010,4-1,24),1],
[Date.UTC(2010,5-1,1),1],
[Date.UTC(2010,5-1,6),1],
[Date.UTC(2010,5-1,9),1],
[Date.UTC(2010,5-1,17),1],
[Date.UTC(2010,5-1,22),1],
[Date.UTC(2010,5-1,29),2],
[Date.UTC(2010,7-1,8),1],
[Date.UTC(2010,7-1,9),1],
[Date.UTC(2010,7-1,11),1],
[Date.UTC(2010,7-1,24),1],
[Date.UTC(2010,8-1,9),1],
[Date.UTC(2010,8-1,11),1],
[Date.UTC(2010,8-1,17),1],
[Date.UTC(2010,8-1,20),1],
[Date.UTC(2010,8-1,27),1],
[Date.UTC(2010,9-1,11),1],
[Date.UTC(2010,9-1,12),1],
[Date.UTC(2010,9-1,15),1],
[Date.UTC(2010,9-1,19),1],
[Date.UTC(2010,9-1,24),1],
[Date.UTC(2010,10-1,3),2],
[Date.UTC(2010,10-1,4),1],
[Date.UTC(2010,10-1,8),1],
[Date.UTC(2010,10-1,9),1],
[Date.UTC(2010,10-1,23),2],
[Date.UTC(2010,10-1,24),1],
[Date.UTC(2010,11-1,14),1],
[Date.UTC(2010,11-1,16),1],
[Date.UTC(2010,12-1,24),1],
[Date.UTC(2011,2-1,13),2],
[Date.UTC(2011,2-1,18),1],
[Date.UTC(2011,3-1,16),1],
[Date.UTC(2011,4-1,24),1],
[Date.UTC(2011,5-1,3),1],
[Date.UTC(2011,5-1,21),1],
[Date.UTC(2011,5-1,26),1],
[Date.UTC(2011,5-1,27),2],
[Date.UTC(2011,5-1,29),2],
[Date.UTC(2011,6-1,4),1],
[Date.UTC(2011,6-1,15),1],
[Date.UTC(2011,7-1,16),1],
[Date.UTC(2011,7-1,24),1],
[Date.UTC(2011,7-1,30),1],
[Date.UTC(2011,7-1,31),1],
[Date.UTC(2011,8-1,10),2],
[Date.UTC(2011,8-1,18),1],
[Date.UTC(2011,9-1,1),2],
[Date.UTC(2011,9-1,2),2],
[Date.UTC(2011,9-1,9),1],
[Date.UTC(2011,9-1,26),1],
[Date.UTC(2011,10-1,19),1],
[Date.UTC(2011,10-1,23),1],
[Date.UTC(2011,11-1,5),2],
[Date.UTC(2011,11-1,6),1],
[Date.UTC(2011,12-1,4),1],
[Date.UTC(2011,12-1,9),1],
[Date.UTC(2011,12-1,24),2],
[Date.UTC(2011,12-1,30),1],
[Date.UTC(2012,1-1,7),1],
[Date.UTC(2012,1-1,12),3],
[Date.UTC(2012,1-1,16),1],
[Date.UTC(2012,1-1,22),1],
[Date.UTC(2012,1-1,31),1],
[Date.UTC(2012,2-1,2),1],
[Date.UTC(2012,2-1,3),1],
[Date.UTC(2012,3-1,4),1],
[Date.UTC(2012,5-1,13),2],
[Date.UTC(2012,5-1,20),1],
[Date.UTC(2012,5-1,24),1],
[Date.UTC(2012,6-1,9),1],
[Date.UTC(2012,7-1,12),1],
[Date.UTC(2012,7-1,20),1],
[Date.UTC(2012,8-1,21),1],
[Date.UTC(2012,8-1,26),1],
[Date.UTC(2012,9-1,6),1],
[Date.UTC(2012,9-1,9),1],
[Date.UTC(2012,9-1,13),1],
[Date.UTC(2012,9-1,29),1],
[Date.UTC(2012,10-1,11),1],
[Date.UTC(2012,10-1,13),1],
[Date.UTC(2012,11-1,3),1],
[Date.UTC(2012,11-1,28),1],
[Date.UTC(2012,12-1,6),1],
[Date.UTC(2012,12-1,12),1],
[Date.UTC(2012,12-1,13),1],
[Date.UTC(2012,12-1,15),1],
[Date.UTC(2012,12-1,16),2],
[Date.UTC(2012,12-1,20),1],
[Date.UTC(2013,1-1,10),2],
[Date.UTC(2013,1-1,20),1],
[Date.UTC(2013,2-1,9),1],
[Date.UTC(2013,2-1,14),1],
[Date.UTC(2013,3-1,7),1],
[Date.UTC(2013,3-1,27),1],
[Date.UTC(2013,4-1,21),1],
[Date.UTC(2013,4-1,28),1],
[Date.UTC(2013,4-1,30),1],
[Date.UTC(2013,5-1,4),2],
[Date.UTC(2013,5-1,12),2],
[Date.UTC(2013,5-1,18),1],
[Date.UTC(2013,5-1,23),1],
[Date.UTC(2013,5-1,30),1],
[Date.UTC(2013,5-1,31),1],
[Date.UTC(2013,6-1,1),1],
[Date.UTC(2013,6-1,8),1],
[Date.UTC(2013,6-1,9),1],
[Date.UTC(2013,7-1,20),1],
[Date.UTC(2013,7-1,26),2],
[Date.UTC(2013,8-1,1),1],
[Date.UTC(2013,8-1,2),1],
[Date.UTC(2013,8-1,3),2],
[Date.UTC(2013,8-1,6),1],
[Date.UTC(2013,8-1,7),1],
[Date.UTC(2013,8-1,31),1],
[Date.UTC(2013,10-1,18),2],
[Date.UTC(2013,11-1,2),1],
[Date.UTC(2014,1-1,12),1],
[Date.UTC(2014,3-1,9),1],
[Date.UTC(2014,4-1,21),1],
[Date.UTC(2014,5-1,17),3],
[Date.UTC(2014,5-1,18),1],
[Date.UTC(2014,5-1,29),1],
[Date.UTC(2014,6-1,4),1],
[Date.UTC(2014,6-1,8),3],
[Date.UTC(2014,6-1,15),1],
[Date.UTC(2014,8-1,9),2],
[Date.UTC(2014,8-1,13),1],
[Date.UTC(2014,8-1,16),1],
[Date.UTC(2014,8-1,20),1],
[Date.UTC(2014,8-1,23),1],
[Date.UTC(2014,8-1,27),1],
[Date.UTC(2014,8-1,31),1],
[Date.UTC(2014,9-1,4),1],
[Date.UTC(2014,9-1,6),2],
[Date.UTC(2014,9-1,7),2],
[Date.UTC(2014,9-1,10),1],
[Date.UTC(2014,9-1,11),1],
[Date.UTC(2014,9-1,18),2],
[Date.UTC(2014,9-1,27),5],
[Date.UTC(2014,9-1,28),1],
[Date.UTC(2014,9-1,29),1],
[Date.UTC(2014,10-1,5),1],
[Date.UTC(2014,10-1,6),1],
[Date.UTC(2014,10-1,7),1],
[Date.UTC(2014,10-1,10),1],
[Date.UTC(2014,10-1,11),1],
[Date.UTC(2014,10-1,12),1],
[Date.UTC(2014,10-1,13),1],
[Date.UTC(2014,10-1,16),1],
[Date.UTC(2014,10-1,29),2],
[Date.UTC(2014,10-1,30),1],
[Date.UTC(2014,11-1,9),1],
[Date.UTC(2014,11-1,10),1],
[Date.UTC(2014,11-1,12),1],
[Date.UTC(2014,11-1,14),1],
[Date.UTC(2014,11-1,18),1],
[Date.UTC(2014,11-1,19),2],
[Date.UTC(2014,11-1,24),1],
[Date.UTC(2014,11-1,27),1],
[Date.UTC(2014,11-1,30),1],
[Date.UTC(2014,12-1,4),1],
[Date.UTC(2014,12-1,6),1],
[Date.UTC(2014,12-1,30),2],
[Date.UTC(2014,12-1,31),1],
[Date.UTC(2015,1-1,2),2],
[Date.UTC(2015,1-1,3),1],
[Date.UTC(2015,1-1,4),1],
[Date.UTC(2015,1-1,5),1],
[Date.UTC(2015,1-1,10),1],
[Date.UTC(2015,1-1,11),1],
[Date.UTC(2015,1-1,14),2],
[Date.UTC(2015,1-1,19),1],
[Date.UTC(2015,1-1,20),1],
[Date.UTC(2015,1-1,21),1],
[Date.UTC(2015,1-1,22),1],
[Date.UTC(2015,1-1,23),1],
[Date.UTC(2015,1-1,24),2],
[Date.UTC(2015,1-1,25),1],
[Date.UTC(2015,1-1,29),1],
[Date.UTC(2015,2-1,1),1],
[Date.UTC(2015,2-1,6),1],
[Date.UTC(2015,2-1,7),1],
[Date.UTC(2015,2-1,8),2],
[Date.UTC(2015,2-1,10),2],
[Date.UTC(2015,2-1,11),1],
[Date.UTC(2015,2-1,12),1],
[Date.UTC(2015,2-1,14),1],
[Date.UTC(2015,2-1,15),1],
[Date.UTC(2015,2-1,20),1],
[Date.UTC(2015,2-1,22),5],
[Date.UTC(2015,2-1,23),2],
[Date.UTC(2015,2-1,25),1],
[Date.UTC(2015,2-1,28),3],
[Date.UTC(2015,3-1,1),2],
[Date.UTC(2015,3-1,2),1],
[Date.UTC(2015,3-1,3),1],
[Date.UTC(2015,3-1,4),2],
[Date.UTC(2015,3-1,6),1],
[Date.UTC(2015,3-1,8),2],
[Date.UTC(2015,3-1,18),1],
[Date.UTC(2015,3-1,19),1],
[Date.UTC(2015,3-1,21),1],
[Date.UTC(2015,3-1,22),2],
[Date.UTC(2015,3-1,26),1],
[Date.UTC(2015,3-1,28),1],
[Date.UTC(2015,3-1,30),1],
[Date.UTC(2015,3-1,31),1],
[Date.UTC(2015,4-1,3),2],
[Date.UTC(2015,4-1,4),6],
[Date.UTC(2015,4-1,5),3],
[Date.UTC(2015,4-1,7),2],
[Date.UTC(2015,4-1,8),1],
[Date.UTC(2015,4-1,10),1],
[Date.UTC(2015,4-1,12),1],
[Date.UTC(2015,4-1,14),1],
[Date.UTC(2015,4-1,15),2],
[Date.UTC(2015,4-1,16),2],
[Date.UTC(2015,4-1,17),1],
[Date.UTC(2015,4-1,19),3],
[Date.UTC(2015,4-1,21),1],
[Date.UTC(2015,4-1,22),1],
[Date.UTC(2015,4-1,23),1],
[Date.UTC(2015,4-1,25),2],
[Date.UTC(2015,4-1,26),1],
[Date.UTC(2015,4-1,30),1],
[Date.UTC(2015,5-1,1),1],
[Date.UTC(2015,5-1,2),2],
[Date.UTC(2015,5-1,3),1],
[Date.UTC(2015,5-1,4),5],
[Date.UTC(2015,5-1,6),4],
[Date.UTC(2015,5-1,8),7],
[Date.UTC(2015,5-1,9),2],
[Date.UTC(2015,5-1,10),6],
[Date.UTC(2015,5-1,11),12],
[Date.UTC(2015,5-1,19),3],
[Date.UTC(2015,5-1,22),1],
[Date.UTC(2015,5-1,23),6],
[Date.UTC(2015,5-1,25),2],
[Date.UTC(2015,5-1,28),1],
[Date.UTC(2015,5-1,30),5],
[Date.UTC(2015,5-1,31),8],
[Date.UTC(2015,6-1,2),1],
[Date.UTC(2015,6-1,3),6],
[Date.UTC(2015,6-1,5),4],
[Date.UTC(2015,6-1,6),7],
[Date.UTC(2015,6-1,7),12],
[Date.UTC(2015,6-1,8),1],
[Date.UTC(2015,6-1,13),4],
[Date.UTC(2015,6-1,14),8],
[Date.UTC(2015,6-1,17),1],
[Date.UTC(2015,6-1,20),1],
[Date.UTC(2015,6-1,21),1],
[Date.UTC(2015,6-1,22),9],
[Date.UTC(2015,6-1,23),1],
[Date.UTC(2015,6-1,25),4],
[Date.UTC(2015,6-1,26),6],
[Date.UTC(2015,6-1,27),17],
[Date.UTC(2015,6-1,28),3],
[Date.UTC(2015,6-1,29),9],
[Date.UTC(2015,7-1,2),1],
[Date.UTC(2015,7-1,5),2],
[Date.UTC(2015,7-1,6),2],
[Date.UTC(2015,7-1,7),2],
[Date.UTC(2015,7-1,8),2],
[Date.UTC(2015,7-1,10),10],
[Date.UTC(2015,7-1,11),14],
[Date.UTC(2015,7-1,12),7],
[Date.UTC(2015,7-1,13),1],
[Date.UTC(2015,7-1,14),7],
[Date.UTC(2015,7-1,15),5],
[Date.UTC(2015,7-1,17),4],
[Date.UTC(2015,7-1,18),5],
[Date.UTC(2015,7-1,23),1],
[Date.UTC(2015,7-1,24),1],
[Date.UTC(2015,7-1,25),32],
[Date.UTC(2015,7-1,26),29],
[Date.UTC(2015,7-1,30),1],
[Date.UTC(2015,7-1,31),1],
[Date.UTC(2015,8-1,1),3],
[Date.UTC(2015,8-1,7),3],
[Date.UTC(2015,8-1,8),4],
[Date.UTC(2015,8-1,12),1],
[Date.UTC(2015,8-1,13),3],
[Date.UTC(2015,8-1,15),8],
[Date.UTC(2015,8-1,16),4],
[Date.UTC(2015,8-1,17),1],
[Date.UTC(2015,8-1,19),4],
[Date.UTC(2015,8-1,20),2],
[Date.UTC(2015,8-1,21),6],
[Date.UTC(2015,8-1,23),3],
[Date.UTC(2015,8-1,27),4],
[Date.UTC(2015,8-1,28),2],
[Date.UTC(2015,8-1,29),19],
[Date.UTC(2015,8-1,30),5],
[Date.UTC(2015,9-1,1),1],
[Date.UTC(2015,9-1,4),6],
[Date.UTC(2015,9-1,5),8],
[Date.UTC(2015,9-1,6),18],
[Date.UTC(2015,9-1,7),2],
[Date.UTC(2015,9-1,8),4],
[Date.UTC(2015,9-1,9),3],
[Date.UTC(2015,9-1,11),1],
[Date.UTC(2015,9-1,12),2],
[Date.UTC(2015,9-1,14),1],
[Date.UTC(2015,9-1,15),6],
[Date.UTC(2015,9-1,17),8],
[Date.UTC(2015,9-1,19),6],
[Date.UTC(2015,9-1,20),11],
[Date.UTC(2015,9-1,21),1],
[Date.UTC(2015,9-1,23),1],
[Date.UTC(2015,9-1,24),4],
[Date.UTC(2015,9-1,25),10],
[Date.UTC(2015,9-1,26),17],
[Date.UTC(2015,9-1,27),2],
[Date.UTC(2015,9-1,28),1],
[Date.UTC(2015,9-1,29),4],
[Date.UTC(2015,9-1,30),1],
[Date.UTC(2015,10-1,5),5],
[Date.UTC(2015,10-1,9),2],
[Date.UTC(2015,10-1,11),6],
[Date.UTC(2015,10-1,12),1],
[Date.UTC(2015,10-1,13),13],
[Date.UTC(2015,10-1,14),16],
[Date.UTC(2015,10-1,15),4],
[Date.UTC(2015,10-1,16),4],
[Date.UTC(2015,10-1,17),1],
[Date.UTC(2015,10-1,19),2],
[Date.UTC(2015,10-1,21),7],
[Date.UTC(2015,10-1,22),4],
[Date.UTC(2015,10-1,27),1],
[Date.UTC(2015,10-1,29),5],
[Date.UTC(2015,10-1,31),1],
[Date.UTC(2015,11-1,1),3],
[Date.UTC(2015,11-1,2),5],
[Date.UTC(2015,11-1,5),2],
[Date.UTC(2015,11-1,7),2],
[Date.UTC(2015,11-1,8),2],
[Date.UTC(2015,11-1,15),3],
[Date.UTC(2015,11-1,16),2],
[Date.UTC(2015,11-1,17),1],
[Date.UTC(2015,11-1,19),1],
[Date.UTC(2015,11-1,20),6],
[Date.UTC(2015,11-1,24),1],
[Date.UTC(2015,11-1,25),2],
[Date.UTC(2015,11-1,27),6],
[Date.UTC(2015,11-1,29),2],
[Date.UTC(2015,12-1,2),1],
[Date.UTC(2015,12-1,3),1],
[Date.UTC(2015,12-1,4),3],
[Date.UTC(2015,12-1,6),1],
[Date.UTC(2015,12-1,8),4],
[Date.UTC(2015,12-1,14),3],
[Date.UTC(2015,12-1,15),3],
[Date.UTC(2015,12-1,16),3],
[Date.UTC(2015,12-1,17),5],
[Date.UTC(2015,12-1,18),1],
[Date.UTC(2015,12-1,19),2],
[Date.UTC(2015,12-1,20),9],
[Date.UTC(2015,12-1,21),4],
[Date.UTC(2015,12-1,22),1],
[Date.UTC(2015,12-1,24),2],
[Date.UTC(2015,12-1,25),3],
[Date.UTC(2015,12-1,26),5],
[Date.UTC(2015,12-1,27),1],
[Date.UTC(2015,12-1,28),1],
[Date.UTC(2015,12-1,29),4],
[Date.UTC(2016,1-1,3),7],
[Date.UTC(2016,1-1,4),4],
[Date.UTC(2016,1-1,6),1],
[Date.UTC(2016,1-1,7),3],
[Date.UTC(2016,1-1,8),4],
[Date.UTC(2016,1-1,9),1],
[Date.UTC(2016,1-1,10),1],
[Date.UTC(2016,1-1,12),1],
[Date.UTC(2016,1-1,14),10],
[Date.UTC(2016,1-1,15),2],
[Date.UTC(2016,1-1,16),1],
[Date.UTC(2016,1-1,17),9],
[Date.UTC(2016,1-1,22),1],
[Date.UTC(2016,1-1,25),1],
[Date.UTC(2016,2-1,2),2],
[Date.UTC(2016,2-1,3),1],
[Date.UTC(2016,2-1,8),1],
[Date.UTC(2016,2-1,10),1],
[Date.UTC(2016,2-1,13),12],
[Date.UTC(2016,2-1,16),1],
[Date.UTC(2016,2-1,19),1],
[Date.UTC(2016,2-1,21),5],
[Date.UTC(2016,2-1,24),3],
[Date.UTC(2016,2-1,25),2],
[Date.UTC(2016,2-1,28),1],
[Date.UTC(2016,3-1,1),2],
[Date.UTC(2016,3-1,3),3],
[Date.UTC(2016,3-1,4),2],
[Date.UTC(2016,3-1,5),1],
[Date.UTC(2016,3-1,8),1],
[Date.UTC(2016,3-1,9),2],
[Date.UTC(2016,3-1,11),2],
[Date.UTC(2016,3-1,12),3],
[Date.UTC(2016,3-1,15),1],
[Date.UTC(2016,3-1,16),1],
[Date.UTC(2016,3-1,17),1],
[Date.UTC(2016,3-1,18),1],
[Date.UTC(2016,3-1,19),2],
[Date.UTC(2016,3-1,20),5],
[Date.UTC(2016,3-1,22),2],
[Date.UTC(2016,3-1,23),1],
[Date.UTC(2016,3-1,25),1],
[Date.UTC(2016,3-1,26),1],
[Date.UTC(2016,3-1,28),3],
[Date.UTC(2016,4-1,1),20],
[Date.UTC(2016,4-1,2),10],
[Date.UTC(2016,4-1,3),1],
[Date.UTC(2016,4-1,5),1],
[Date.UTC(2016,4-1,7),4],
[Date.UTC(2016,4-1,8),2],
[Date.UTC(2016,4-1,9),2],
[Date.UTC(2016,4-1,11),1],
[Date.UTC(2016,4-1,15),1],
[Date.UTC(2016,4-1,16),1],
[Date.UTC(2016,4-1,17),5],
[Date.UTC(2016,4-1,18),2],
[Date.UTC(2016,4-1,19),11],
[Date.UTC(2016,4-1,20),3],
[Date.UTC(2016,4-1,21),3],
[Date.UTC(2016,4-1,22),10],
[Date.UTC(2016,4-1,23),7],
[Date.UTC(2016,4-1,24),1],
[Date.UTC(2016,4-1,25),11],
[Date.UTC(2016,4-1,26),3],
[Date.UTC(2016,4-1,28),3],
[Date.UTC(2016,4-1,29),1],
[Date.UTC(2016,4-1,30),2],
[Date.UTC(2016,5-1,2),3],
[Date.UTC(2016,5-1,3),6],
[Date.UTC(2016,5-1,4),21],
[Date.UTC(2016,5-1,5),3],
[Date.UTC(2016,5-1,6),3],
[Date.UTC(2016,5-1,7),1],
[Date.UTC(2016,5-1,8),2],
[Date.UTC(2016,5-1,9),10],
[Date.UTC(2016,5-1,12),7],
[Date.UTC(2016,5-1,17),1],
[Date.UTC(2016,5-1,18),1],
[Date.UTC(2016,5-1,19),12],
[Date.UTC(2016,5-1,20),6],
[Date.UTC(2016,5-1,21),27],
[Date.UTC(2016,5-1,22),5],
[Date.UTC(2016,5-1,23),3],
[Date.UTC(2016,5-1,24),1],
[Date.UTC(2016,5-1,26),20],
[Date.UTC(2016,5-1,27),10],
[Date.UTC(2016,5-1,28),3],
[Date.UTC(2016,5-1,29),4],
[Date.UTC(2016,5-1,30),8],
[Date.UTC(2016,5-1,31),1],
[Date.UTC(2016,6-1,1),4],
[Date.UTC(2016,6-1,2),6],
[Date.UTC(2016,6-1,3),4],
[Date.UTC(2016,6-1,4),12],
[Date.UTC(2016,6-1,5),2],
[Date.UTC(2016,6-1,6),10],
[Date.UTC(2016,6-1,7),2],
[Date.UTC(2016,6-1,8),11],
[Date.UTC(2016,6-1,9),2],
[Date.UTC(2016,6-1,11),3],
[Date.UTC(2016,6-1,12),5],
[Date.UTC(2016,6-1,15),2],
[Date.UTC(2016,6-1,16),1],
[Date.UTC(2016,6-1,17),6],
[Date.UTC(2016,6-1,18),4],
[Date.UTC(2016,6-1,19),2],
[Date.UTC(2016,6-1,22),3],
[Date.UTC(2016,6-1,23),2],
[Date.UTC(2016,6-1,24),6],
[Date.UTC(2016,6-1,25),12],
[Date.UTC(2016,6-1,26),31],
[Date.UTC(2016,6-1,27),1],
[Date.UTC(2016,7-1,3),7],
[Date.UTC(2016,7-1,5),22],
[Date.UTC(2016,7-1,6),1],
[Date.UTC(2016,7-1,7),4],
[Date.UTC(2016,7-1,9),2],
[Date.UTC(2016,7-1,11),3],
[Date.UTC(2016,7-1,12),3],
[Date.UTC(2016,7-1,14),7],
[Date.UTC(2016,7-1,15),3],
[Date.UTC(2016,7-1,19),4],
[Date.UTC(2016,7-1,20),5],
[Date.UTC(2016,7-1,21),16],
[Date.UTC(2016,7-1,22),7],
[Date.UTC(2016,7-1,23),1],
[Date.UTC(2016,7-1,24),6],
[Date.UTC(2016,7-1,26),4],
[Date.UTC(2016,7-1,27),5],
[Date.UTC(2016,7-1,28),9],
[Date.UTC(2016,7-1,29),6],
[Date.UTC(2016,7-1,30),5],
[Date.UTC(2016,8-1,2),1],
[Date.UTC(2016,8-1,3),49],
[Date.UTC(2016,8-1,4),1],
[Date.UTC(2016,8-1,5),8],
[Date.UTC(2016,8-1,6),1],
[Date.UTC(2016,8-1,7),2],
[Date.UTC(2016,8-1,8),1],
[Date.UTC(2016,8-1,10),1],
[Date.UTC(2016,8-1,11),3],
[Date.UTC(2016,8-1,12),6],
[Date.UTC(2016,8-1,13),55],
[Date.UTC(2016,8-1,14),3],
[Date.UTC(2016,8-1,15),3],
[Date.UTC(2016,8-1,18),5],
[Date.UTC(2016,8-1,19),10],
[Date.UTC(2016,8-1,20),3],
[Date.UTC(2016,8-1,22),3],
[Date.UTC(2016,8-1,23),3],
[Date.UTC(2016,8-1,24),3],
[Date.UTC(2016,8-1,27),1],
[Date.UTC(2016,8-1,30),9],
[Date.UTC(2016,8-1,31),8],
[Date.UTC(2016,9-1,1),1],
[Date.UTC(2016,9-1,3),10],
[Date.UTC(2016,9-1,4),2],
[Date.UTC(2016,9-1,5),1],
[Date.UTC(2016,9-1,7),5],
[Date.UTC(2016,9-1,8),1],
[Date.UTC(2016,9-1,10),1],
[Date.UTC(2016,9-1,11),2],
[Date.UTC(2016,9-1,13),1],
[Date.UTC(2016,9-1,15),2],
[Date.UTC(2016,9-1,16),1],
[Date.UTC(2016,9-1,18),1],
[Date.UTC(2016,9-1,21),1],
[Date.UTC(2016,9-1,22),3],
[Date.UTC(2016,9-1,23),1],
[Date.UTC(2016,9-1,24),7],
[Date.UTC(2016,9-1,25),1],
[Date.UTC(2016,9-1,28),2],
[Date.UTC(2016,10-1,1),9],
[Date.UTC(2016,10-1,2),3],
[Date.UTC(2016,10-1,4),6],
[Date.UTC(2016,10-1,5),1],
[Date.UTC(2016,10-1,6),3],
[Date.UTC(2016,10-1,7),5],
[Date.UTC(2016,10-1,10),9],
[Date.UTC(2016,10-1,11),5],
[Date.UTC(2016,10-1,12),3],
[Date.UTC(2016,10-1,13),5],
[Date.UTC(2016,10-1,14),2],
[Date.UTC(2016,10-1,17),3],
[Date.UTC(2016,10-1,18),2],
[Date.UTC(2016,10-1,19),9],
[Date.UTC(2016,10-1,20),5],
[Date.UTC(2016,10-1,21),8],
[Date.UTC(2016,10-1,23),1],
[Date.UTC(2016,10-1,24),2],
[Date.UTC(2016,10-1,29),2],
[Date.UTC(2016,10-1,30),5],
[Date.UTC(2016,11-1,3),5],
[Date.UTC(2016,11-1,5),3],
[Date.UTC(2016,11-1,6),2],
[Date.UTC(2016,11-1,7),10],
[Date.UTC(2016,11-1,8),2],
[Date.UTC(2016,11-1,13),4],
[Date.UTC(2016,11-1,14),10],
[Date.UTC(2016,11-1,15),5],
[Date.UTC(2016,11-1,16),4],
[Date.UTC(2016,11-1,17),4],
[Date.UTC(2016,11-1,19),26],
[Date.UTC(2016,11-1,20),3],
[Date.UTC(2016,11-1,21),3],
[Date.UTC(2016,11-1,23),1],
[Date.UTC(2016,11-1,25),2],
[Date.UTC(2016,11-1,26),6],
[Date.UTC(2016,11-1,27),11],
[Date.UTC(2016,11-1,28),2],
[Date.UTC(2016,11-1,29),7],
[Date.UTC(2016,11-1,30),8],
[Date.UTC(2016,12-1,1),2],
[Date.UTC(2016,12-1,2),9],
[Date.UTC(2016,12-1,5),1],
[Date.UTC(2016,12-1,6),1],
[Date.UTC(2016,12-1,12),4],
[Date.UTC(2016,12-1,13),5],
[Date.UTC(2016,12-1,17),7],
[Date.UTC(2016,12-1,18),2],
[Date.UTC(2016,12-1,20),1],
[Date.UTC(2016,12-1,24),2],
[Date.UTC(2016,12-1,25),1],
[Date.UTC(2016,12-1,27),3],
[Date.UTC(2016,12-1,28),1],
[Date.UTC(2016,12-1,29),1],
[Date.UTC(2016,12-1,30),3],
[Date.UTC(2017,1-1,3),1],
[Date.UTC(2017,1-1,7),1],
[Date.UTC(2017,1-1,12),1],
[Date.UTC(2017,1-1,13),1],
[Date.UTC(2017,1-1,19),3],
[Date.UTC(2017,1-1,20),1],
[Date.UTC(2017,1-1,22),7],
[Date.UTC(2017,1-1,26),5],
[Date.UTC(2017,1-1,27),3],
[Date.UTC(2017,1-1,28),1],
[Date.UTC(2017,1-1,30),1],
[Date.UTC(2017,1-1,31),3],
[Date.UTC(2017,2-1,1),1],
[Date.UTC(2017,2-1,2),1],
[Date.UTC(2017,2-1,6),2],
[Date.UTC(2017,2-1,8),1],
[Date.UTC(2017,2-1,10),4],
[Date.UTC(2017,2-1,11),2],
[Date.UTC(2017,2-1,12),13],
[Date.UTC(2017,2-1,13),1],
[Date.UTC(2017,2-1,15),1],
[Date.UTC(2017,2-1,16),1],
[Date.UTC(2017,2-1,18),13],
[Date.UTC(2017,2-1,19),9],
[Date.UTC(2017,2-1,22),9],
[Date.UTC(2017,2-1,23),3],
[Date.UTC(2017,2-1,24),2],
[Date.UTC(2017,2-1,25),15],
[Date.UTC(2017,2-1,27),2],
[Date.UTC(2017,2-1,28),5],
[Date.UTC(2017,3-1,1),6],
[Date.UTC(2017,3-1,2),3],
[Date.UTC(2017,3-1,3),1],
[Date.UTC(2017,3-1,4),2],
[Date.UTC(2017,3-1,6),3],
[Date.UTC(2017,3-1,7),3],
[Date.UTC(2017,3-1,9),9],
[Date.UTC(2017,3-1,10),1],
[Date.UTC(2017,3-1,11),3],
[Date.UTC(2017,3-1,13),1],
[Date.UTC(2017,3-1,14),4],
[Date.UTC(2017,3-1,15),1],
[Date.UTC(2017,3-1,17),3],
[Date.UTC(2017,3-1,18),4],
[Date.UTC(2017,3-1,19),8],
[Date.UTC(2017,3-1,20),6],
[Date.UTC(2017,3-1,21),11],
[Date.UTC(2017,3-1,23),8],
[Date.UTC(2017,3-1,24),5],
[Date.UTC(2017,3-1,25),6],
[Date.UTC(2017,3-1,26),7],
[Date.UTC(2017,3-1,28),4],
[Date.UTC(2017,3-1,29),7],
[Date.UTC(2017,3-1,30),5],
[Date.UTC(2017,4-1,3),1],
[Date.UTC(2017,4-1,5),3],
[Date.UTC(2017,4-1,6),1],
[Date.UTC(2017,4-1,7),12],
[Date.UTC(2017,4-1,8),1],
[Date.UTC(2017,4-1,9),2],
[Date.UTC(2017,4-1,10),18],
[Date.UTC(2017,4-1,11),9],
[Date.UTC(2017,4-1,14),44],
[Date.UTC(2017,4-1,15),2],
[Date.UTC(2017,4-1,16),1],
[Date.UTC(2017,4-1,17),5],
[Date.UTC(2017,4-1,20),37],
[Date.UTC(2017,4-1,21),1],
[Date.UTC(2017,4-1,22),1],
[Date.UTC(2017,4-1,23),1],
[Date.UTC(2017,4-1,26),1],
[Date.UTC(2017,4-1,27),2],
[Date.UTC(2017,4-1,28),3],
[Date.UTC(2017,4-1,29),10],
[Date.UTC(2017,4-1,30),6],
[Date.UTC(2017,5-1,1),11],
[Date.UTC(2017,5-1,2),1],
[Date.UTC(2017,5-1,3),3],
[Date.UTC(2017,5-1,4),12],
[Date.UTC(2017,5-1,5),1],
[Date.UTC(2017,5-1,6),1],
[Date.UTC(2017,5-1,8),1],
[Date.UTC(2017,5-1,10),5],
[Date.UTC(2017,5-1,12),3],
[Date.UTC(2017,5-1,16),1],
[Date.UTC(2017,5-1,17),18],
[Date.UTC(2017,5-1,18),27],
[Date.UTC(2017,5-1,19),1],
[Date.UTC(2017,5-1,21),1],
[Date.UTC(2017,5-1,22),3],
[Date.UTC(2017,5-1,23),5],
[Date.UTC(2017,5-1,24),8],
[Date.UTC(2017,5-1,25),11],
[Date.UTC(2017,5-1,26),15],
[Date.UTC(2017,5-1,27),55],
[Date.UTC(2017,5-1,28),20],
[Date.UTC(2017,5-1,29),1],
[Date.UTC(2017,5-1,30),1],
[Date.UTC(2017,6-1,1),4],
[Date.UTC(2017,6-1,2),3],
[Date.UTC(2017,6-1,3),25],
[Date.UTC(2017,6-1,4),100],
[Date.UTC(2017,6-1,6),2],
[Date.UTC(2017,6-1,8),1],
[Date.UTC(2017,6-1,10),4],
[Date.UTC(2017,6-1,11),1],
[Date.UTC(2017,6-1,12),2],
[Date.UTC(2017,6-1,13),1],
[Date.UTC(2017,6-1,14),1],
[Date.UTC(2017,6-1,15),6],
[Date.UTC(2017,6-1,16),1],
[Date.UTC(2017,6-1,17),4],
[Date.UTC(2017,6-1,18),2],
[Date.UTC(2017,6-1,20),7],
[Date.UTC(2017,6-1,22),1],
[Date.UTC(2017,6-1,23),1],
[Date.UTC(2017,6-1,24),1],
[Date.UTC(2017,6-1,26),3],
[Date.UTC(2017,6-1,27),1],
[Date.UTC(2017,6-1,28),5],
[Date.UTC(2017,6-1,29),3],
[Date.UTC(2017,6-1,30),3],
[Date.UTC(2017,7-1,1),1],
[Date.UTC(2017,7-1,2),1],
[Date.UTC(2017,7-1,4),1],
[Date.UTC(2017,7-1,5),3],
[Date.UTC(2017,7-1,6),6],
[Date.UTC(2017,7-1,8),1],
[Date.UTC(2017,7-1,9),13],
[Date.UTC(2017,7-1,10),5],
[Date.UTC(2017,7-1,15),3],
[Date.UTC(2017,7-1,16),2],
[Date.UTC(2017,7-1,17),1],
[Date.UTC(2017,7-1,18),1],
[Date.UTC(2017,7-1,19),2],
[Date.UTC(2017,7-1,23),11],
[Date.UTC(2017,7-1,27),3],
[Date.UTC(2017,7-1,28),3],
[Date.UTC(2017,7-1,30),15],
[Date.UTC(2017,7-1,31),2],
[Date.UTC(2017,8-1,3),4],
[Date.UTC(2017,8-1,4),2],
[Date.UTC(2017,8-1,5),1],
[Date.UTC(2017,8-1,6),1],
[Date.UTC(2017,8-1,7),5],
[Date.UTC(2017,8-1,8),5],
[Date.UTC(2017,8-1,9),3],
[Date.UTC(2017,8-1,10),1],
[Date.UTC(2017,8-1,11),1],
[Date.UTC(2017,8-1,12),2],
[Date.UTC(2017,8-1,13),1],
[Date.UTC(2017,8-1,14),6],
[Date.UTC(2017,8-1,15),1],
[Date.UTC(2017,8-1,16),4],
[Date.UTC(2017,8-1,18),1],
[Date.UTC(2017,8-1,20),8],
[Date.UTC(2017,8-1,21),1],
[Date.UTC(2017,8-1,23),4],
[Date.UTC(2017,8-1,24),5],
[Date.UTC(2017,8-1,25),11],
[Date.UTC(2017,8-1,26),7],
[Date.UTC(2017,8-1,27),32],
[Date.UTC(2017,8-1,28),2],
[Date.UTC(2017,9-1,3),1],
[Date.UTC(2017,9-1,4),1],
[Date.UTC(2017,9-1,5),3],
[Date.UTC(2017,9-1,9),15],
[Date.UTC(2017,9-1,10),1],
[Date.UTC(2017,9-1,11),5],
[Date.UTC(2017,9-1,13),9],
[Date.UTC(2017,9-1,14),16],
[Date.UTC(2017,9-1,15),24],
[Date.UTC(2017,9-1,16),4],
[Date.UTC(2017,9-1,17),3],
[Date.UTC(2017,9-1,19),1],
[Date.UTC(2017,9-1,22),4],
[Date.UTC(2017,9-1,23),2],
[Date.UTC(2017,9-1,24),2],
[Date.UTC(2017,9-1,25),1],
[Date.UTC(2017,9-1,27),1],
[Date.UTC(2017,9-1,28),8],
[Date.UTC(2017,10-1,1),2],
[Date.UTC(2017,10-1,2),1],
[Date.UTC(2017,10-1,6),5],
[Date.UTC(2017,10-1,8),73],
[Date.UTC(2017,10-1,9),2],
[Date.UTC(2017,10-1,15),1],
[Date.UTC(2017,10-1,22),7],
[Date.UTC(2017,11-1,4),1],
[Date.UTC(2017,11-1,10),2],
[Date.UTC(2017,11-1,15),1],
[Date.UTC(2017,11-1,18),1],
[Date.UTC(2017,11-1,19),2],
[Date.UTC(2017,11-1,26),3],
[Date.UTC(2017,11-1,29),1],
[Date.UTC(2017,12-1,3),2],
[Date.UTC(2017,12-1,8),1],
[Date.UTC(2017,12-1,24),1],
[Date.UTC(2018,1-1,1),1],
[Date.UTC(2018,1-1,9),1],
[Date.UTC(2018,1-1,12),1],
[Date.UTC(2018,1-1,13),1],
[Date.UTC(2018,1-1,16),1],
[Date.UTC(2018,1-1,21),2],
[Date.UTC(2018,2-1,2),1],
[Date.UTC(2018,2-1,17),3],
[Date.UTC(2018,2-1,18),2],
[Date.UTC(2018,2-1,24),4],
[Date.UTC(2018,3-1,3),2],
[Date.UTC(2018,3-1,12),1],
[Date.UTC(2018,3-1,21),1],
[Date.UTC(2018,4-1,2),1],
[Date.UTC(2018,4-1,7),1],
[Date.UTC(2018,4-1,20),1],
[Date.UTC(2018,5-1,6),2]
      ]
  }]
};



// WEBPACK FOOTER //
// js/chart1.js